import { Navigation } from "fond/projects/Navigation";
import { PageContent } from "fond/widgets";

import AccountList from "./AccountList";

const Accounts: React.FC = () => {
  return (
    <PageContent
      windowTitle="Accounts"
      title="Accounts"
      subTitle="Member and external accounts"
      mainContent={<AccountList />}
      testId="account-list"
      navigation={<Navigation />}
    />
  );
};

export default Accounts;
